import { motion } from 'framer-motion';
import { Clock, Zap, Users, TrendingUp, Sparkles, Shield } from 'lucide-react';
import HeroSection from '../components/home/HeroSection';
import TimelineSection from '../components/home/TimelineSection';
import FeaturesSection from '../components/home/FeaturesSection';
import TokenomicsSection from '../components/home/TokenomicsSection';
import RoadmapSection from '../components/home/RoadmapSection';
import CTASection from '../components/home/CTASection';

export default function HomePage() {
  return (
    <main className="relative overflow-hidden">
      {/* Background: lighter for faster paint + mobile */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(120,119,198,0.08),transparent_50%)]" />
        <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-[0.07]" />
      </div>

      {/* Content area */}
      <div className="relative z-10">
        {/* Hero */}
        <HeroSection />

        {/* Features */}
        <FeaturesSection />

        {/* Timeline */}
        <TimelineSection />

        {/* Tokenomics */}
        <TokenomicsSection />

        {/* Roadmap */}
        <RoadmapSection />

        {/* CTA */}
        <CTASection />
      </div>
    </main>
  );
}
